'use strict';
/* jshint ignore:start */

var giftcard = {

		payGiftCodeEvent: function (buttonID) {
			if ($('input[name=basketData]').length > 0) {
				var basket = JSON.parse($('input[name=basketData]').val());
			}
			var obj = {
				'event': 'payGiftCode',
				'button_ID':  buttonID,
				'checkout_type': basket.checkout_type
			};
			dataLayer.push(obj);
		}
};
module.exports = giftcard;
/* jshint ignore:end */
